import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { CATEGORIES, SALON, ANNOUNCEMENTS, byCategory } from "../../data/salon";
import { toFa } from "../../lib/format";
import { useScrollDirection } from "../../lib/motion";
import { useBooking } from "../../lib/booking";
import "./layout.css";

const NAV = [
  { to: "/services", label: "خدمات", mega: true },
  { to: "/staff", label: "متخصصین" },
  { to: "/portfolio", label: "نمونه‌کارها" },
  { to: "/offers", label: "پیشنهادها" },
];

function AnnouncementBar() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((n) => (n + 1) % ANNOUNCEMENTS.length), 4200);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="abar">
      <div className="abar__viewport">
        {ANNOUNCEMENTS.map((text, n) => (
          <span key={text} className={`abar__item${n === i ? " is-on" : ""}`}>
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function Header() {
  const { solid, hidden } = useScrollDirection();
  const [mega, setMega] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const booking = useBooking();
  const { pathname } = useLocation();
  // the homepage hero is a dark photograph — the header has to invert over it
  const overDark = pathname === "/" && !solid;

  // Any navigation closes whatever was open.
  useEffect(() => {
    setMega(false);
    setDrawer(false);
  }, [pathname]);

  useEffect(() => {
    if (!drawer) return undefined;
    const onKey = (e) => e.key === "Escape" && setDrawer(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [drawer]);

  return (
    <>
      <AnnouncementBar />

      <header
        className={`hdr${solid ? " is-solid" : ""}${overDark ? " is-onDark" : ""}${hidden && !mega ? " is-hidden" : ""}`}
        onMouseLeave={() => setMega(false)}
      >
        <div className="hdr__inner wrap wrap--wide">
          <button
            type="button"
            className="hdr__burger"
            aria-label="منو"
            aria-expanded={drawer}
            onClick={() => setDrawer((d) => !d)}
          >
            <span /><span /><span />
          </button>

          <Link to="/" className="hdr__logo" aria-label={`${SALON.name} — ${SALON.tagline}`}>
            <span className="hdr__mark">{SALON.name}</span>
            <span className="hdr__latin">{SALON.latin}</span>
          </Link>

          <nav className="hdr__nav" aria-label="ناوبری اصلی">
            {NAV.map((item) => (
              <div
                key={item.to}
                className="hdr__navitem"
                onMouseEnter={() => setMega(!!item.mega)}
              >
                <NavLink
                  to={item.to}
                  className={({ isActive }) => `hdr__link${isActive ? " is-active" : ""}`}
                >
                  {item.label}
                </NavLink>
              </div>
            ))}
          </nav>

          <div className="hdr__actions">
            <button
              type="button"
              className="hdr__basket"
              onClick={() => booking.setOpen(true)}
              aria-label={`سبد نوبت، ${toFa(booking.count)} خدمت`}
            >
              <span className="hdr__basketIcon" aria-hidden="true">◇</span>
              {booking.count > 0 && (
                <span className="hdr__count">{toFa(booking.count)}</span>
              )}
            </button>

            <Link to="/booking" className="btn btn--sm hdr__cta">رزرو نوبت</Link>
          </div>
        </div>

        {/* ------------------------------------------------------- mega */}
        <div className={`mega${mega ? " is-open" : ""}`} onMouseLeave={() => setMega(false)}>
          <div className="mega__inner wrap wrap--wide">
            {CATEGORIES.map((c) => (
              <div key={c.slug} className="mega__col">
                <Link to={`/services?c=${c.slug}`} className="mega__title">
                  {c.label}
                  <span className="mega__latin">{c.latin}</span>
                </Link>

                <ul className="mega__list">
                  {byCategory(c.slug).slice(0, 4).map((s) => (
                    <li key={s.id}>
                      <Link to={`/services/${s.slug}`}>{s.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="mega__promo">
              <span className="eyebrow eyebrow--gold">FIRST VISIT</span>
              <p>اولین مراجعه‌ات با بیست درصد تخفیف.</p>
              <Link to="/offers" className="tlink">
                پیشنهادها<span className="tlink__arrow">←</span>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* ------------------------------------------------------ mobile */}
      <div
        className={`mdrawer${drawer ? " is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="منوی موبایل"
      >
        <button
          type="button"
          className="mdrawer__scrim"
          aria-label="بستن منو"
          onClick={() => setDrawer(false)}
        />

        <div className="mdrawer__panel">
          <div className="mdrawer__head">
            <span className="hdr__mark">{SALON.name}</span>
            <button type="button" onClick={() => setDrawer(false)} aria-label="بستن">✕</button>
          </div>

          <nav className="mdrawer__nav">
            <NavLink to="/">خانه</NavLink>
            {NAV.map((i) => (
              <NavLink key={i.to} to={i.to}>{i.label}</NavLink>
            ))}
          </nav>

          <div className="mdrawer__cats">
            <span className="eyebrow">CATEGORIES</span>
            {CATEGORIES.map((c) => (
              <Link key={c.slug} to={`/services?c=${c.slug}`}>{c.label}</Link>
            ))}
          </div>

          <Link to="/booking" className="btn btn--block">رزرو نوبت</Link>
        </div>
      </div>
    </>
  );
}
